function TosPage() {

    return (
        <div className="p-3">
            <h1>🤝 Terms of Services</h1>

            <div className="row gy-3">
                <div className="col-12">
                    qsd
                </div>
            </div>
        </div>
    );
}

export default TosPage;
